module.exports = __webpack_public_path__ + "img/6.c56171b7.png";